import axios from 'axios';
import { apiUrl, execUrl } from 'libs/commonVar';
import * as common from 'libs/commonFunc';

export const getAttach = params => common.requestRaw(apiUrl + 'TemplateAttach', params, 'get');
// export const addAttach = params => common.requestRaw(apiUrl + 'TemplateAttach', params, 'post');
export const copyAttach = params => common.requestRaw(apiUrl + 'TemplateAttach/Copy', params, 'post');
export const updateAttach = params => common.requestRaw(apiUrl + 'TemplateAttach', params, 'put');
export const deleteAttach = params => common.requestRaw(apiUrl + 'TemplateAttach', params, 'delete');

export const addAttach = formData => {
  return axios({
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    url: apiUrl + 'TemplateAttach',
    data: formData
  });
};



// WEBPACK FOOTER //
// ./src/script/libs/attachLib.js